import React from "react";
import { Form } from "react-bootstrap";
import Blue_btn from "../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Orange_btn from "../../../../../../common_components/common_btn/orange_btn/Orange_btn";

function Step5({ onNext, onBack }) {
  return (
    <>
      <div className="mt-4 card_box">
        <div className="heading_text_holder">
          <h1>
            What is the right pronoun? 'This is the book _____ I told you about.
          </h1>
        </div>

        <Form className="mt-3 lt_options">
          <Form.Group className="mb-3">
            <Form.Check
              type="radio"
              name="q8"
              label="That"
              className="lt_option"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="radio"
              name="q8"
              label="Of which"
              className="lt_option"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="radio"
              name="q8"
              label="Who"
              className="lt_option"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="radio"
              name="q8"
              label="Where"
              className="lt_option"
            />
          </Form.Group>
        </Form>

        {/* Buttons */}
        <div className="btn_holder">
          <Orange_btn btn_text="Back" onClick={onBack} />
          <Blue_btn btn_text="Next" onClick={onNext} />
        </div>
      </div>
    </>
  );
}

export default Step5;
